export const LAPTOP_BREAKPOINT = 1200
export const TABLET_BREAKPOINT = 1024
export const MOBILE_BREAKPOINT = 768
export const MEDIUM_MOBILE_BREAKPOINT = 550
export const SMALL_MOBILE_BREAKPOINT = 400
